import { Cell, Text } from '@vinted/web-ui';
import { jsx as _jsx } from "react/jsx-runtime";

const LinkCell = _ref => {
  let {
    title,
    url,
    onClick,
    testId
  } = _ref;
  return /*#__PURE__*/_jsx(Cell, {
    type: Cell.Type.Navigating,
    styling: Cell.Styling.Narrow,
    url: url,
    onClick: onClick,
    body: /*#__PURE__*/_jsx(Text, {
      children: title
    }),
    testId: testId
  });
};

export default LinkCell;